<template>
  <div class="summary-container">
    <div class="summary">
      <h2>Request for Bank Statement</h2>

      <div v-show="activeIndex == 0">
        <div v-if="showRetry">
          <h4>Make Request</h4>
          <lo-mini-tracker
            :tabItems="tabItems"
            :activeIndex="activeIndex"
            ref="progressTracker"
          />
          <p>
            Your request is being treated, please wait for 5 - 10mins to receive
            your ticket number and password.
          </p>

          <div class="footer">
            <!-- real footer item -->
            <div v-if="loader1" className="text-center">
              <div class="submit-gif">
                <div
                  class="spinner-border"
                  style="width: 3rem; height: 3rem; max-width: 17vw;"
                  role="status"
                >
                  <span class="sr-only">Processing...</span>
                </div>
              </div>
            </div>
            <div v-else>
              <button
                @click="retryRequest"
                class="download-button"
                type="button"
              >
                Input
              </button>
            </div>
          </div>
        </div>
        <div v-else>
          <!-- form elements -->
          <h4>Make Request</h4>
          <lo-mini-tracker
            :tabItems="tabItems"
            :activeIndex="activeIndex"
            ref="progressTracker"
          />
          <p>
            Please fill the form to submit bank statement. This will help us
            determine if you’ll be accepted or not.
            <br />
            <i style="fontSize: 12px; marginLeft: 25%;"
              >NB: Six (6) months bank statement would be shared with Arnergy</i
            >
          </p>
          <h3>
            For GT and Zenith bank customers, click
            <a
              href="https://res.cloudinary.com/mentor-africa-project/image/upload/v1647451517/GTZenithworkaround.pdf"
              target="_blank"
              v-bind:style="GTpdf"
            >
              here
            </a>
            for the steps to submit bank statement.
          </h3>

          <form>
            <h4>Bank</h4>
            <input-bank
              v-model="form.bank"
              :items="banks"
              :error="formErrors.bank"
              @getLinked="getLink"
            />

            <div v-show="getLinkData">
              <h4>
                Phone Number (Please ensure it is registered with your account
                number)
              </h4>
              <input-field
                :model="form.phoneNumber"
                v-model="form.phoneNumber"
              />
            </div>

            <div v-show="getLinkData == 'Y'">
              <h4>Account Number</h4>
              <input-field
                v-model="form.accountNo"
                :error="formErrors.accountNo"
              />
            </div>
          </form>

          <!-- real footer item -->
          <div v-if="loader" class="download-button">
            <div class="spinner-border" style="margin: auto;" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div v-else>
            <button @click="makeRequest" class="download-button" type="button">
              Make Request
            </button>
          </div>
        </div>
      </div>

      <div v-show="activeIndex == 1">
        <h4>Confirm Action</h4>
        <lo-mini-tracker
          :tabItems="tabItems"
          :activeIndex="activeIndex"
          ref="progressTracker"
        />
        <p style="max-width: 740px; text-align: center;">
          {{ message }}. For GT & Zenith customers, kindly input the details
          shown on your banking platform.
        </p>

        <form>
          <h4>Ticket ID</h4>
          <input-field
            v-model="form.ticketId"
            :error="formErrors.ticketId"
            label="Ticket ID"
            type="text"
            autocomplete="nopenklnglnmgdlmlmdlmlmlfml"
            name="ticket123"
            id="ticket123"
          />

          <h4>Password</h4>
          <input-field
            v-model="form.password"
            :error="formErrors.password"
            label="Password"
            type="password"
            name="pass123"
            id="pass123"
            autocomplete="new-password"
          />
        </form>

        <!-- real footer item -->
        <div v-if="loaderConfirm" className="text-center">
          <div class="download-button">
            <div
              class="spinner-border"
              style="width: 2rem; height: 2rem"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
        <div v-else>
          <button
            @click="confirmRequest"
            class="download-button-wide"
            type="button"
          >
            Process Request
          </button>
        </div>
      </div>

      <modal
        v-if="showModal"
        @confirmRequest="confirmRequestModal"
        :modalstate="loader"
        @close="showModal = false"
      ></modal>
      <modal-error
        v-if="showModalError"
        :modalstateError="messageModal"
        @close="showModalError = false"
      ></modal-error>

      <div v-show="activeIndex == 2">
        <h4>Summary</h4>
        <lo-mini-tracker
          :tabItems="tabItems"
          :activeIndex="activeIndex"
          ref="progressTracker"
        />

        <div class="summary">
          <div class="summary-table">
            <div>
              <p>Name</p>
              <p>{{ summary.name }}</p>
            </div>
            <div>
              <p>Nuban</p>
              <p>{{ summary.nuban }}</p>
            </div>
            <div>
              <p>Available Balance</p>
              <p>
                NGN
                {{
                  new Intl.NumberFormat("en-US").format(summary.availableBal)
                }}
              </p>
            </div>
            <div class="table-base">
              <p style="color: black">Statement Passed</p>
              <p
                v-if="summary.statementOk"
                style="font-weight: bold; color: green;"
              >
                true
              </p>
              <p v-else style="font-weight: bold; color: red;">false</p>
            </div>
          </div>
        </div>

        <p
          v-if="!bankRequestPassed()"
          style="color: red; text-align: center; margin: 10px auto;"
        >
          Unfortunately, you can't proceed with your request! Please try another
          account.
        </p>
        <p v-else style="color: green; text-align: center; margin: 10px auto;">
          You have passed the bank statement check! Kindly click continue to
          proceed.
        </p>

        <button
          v-if="!bankRequestPassed()"
          @click="(activeIndex = 0), (showRetry = false)"
          class="download-button"
          type="button"
        >
          Retry
        </button>
      </div>
    </div>
    <div class="illustration">
      <div class="description">
        Kindly fill in your bank details. <br />
        Your details are encrypted and safe with us.
      </div>
      <img
        :src="require('../../../../assets/img/polygon.svg')"
        class="polygon"
        alt="Comment Bubble"
      />
      <img :src="require('../../../../assets/img/female-wave.gif')" alt="" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import InputBank from "../components/InputBank.vue";
import InputField from "../components/InputField.vue";
import LoMiniTracker from "../components/LoMiniTracker.vue";
import ArnergySelect from "../../kitchen/ArnergySelect.vue";
import ModalSucess from "../../kitchen/Onboarding/ModalSuccess.vue";
import ModalNotify from "../../kitchen/Onboarding/ModalNotify.vue";

import axios from "axios";
import Modal from "../../kitchen/Onboarding/modal.vue";
import ModalError from "../../kitchen/Onboarding/modal-error.vue";
import ArnergyBank from "../../kitchen/AnergyBank.vue";
import VueSweetalert2 from "vue-sweetalert2";
import Vue from "vue";
import "sweetalert2/dist/sweetalert2.min.css";
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Dialog,
  Radio,
  RadioGroup,
  RadioButton
  // ...
} from "element-ui";
import state from "../../../../store/state";

Vue.use(VueSweetalert2);
export default {
  name: "BankStatement",
  props: ["updateStatus", "updateTracker", "markAsCompleted"],
  components: {
    InputBank,
    InputField,
    LoMiniTracker,
    VueSweetalert2,
    ArnergySelect,
    ModalNotify,
    ModalError,
    Modal,
    ModalSucess,
    "el-dialog": Dialog
  },
  computed: {
    ...mapGetters(["getUserSession"])
  },
  data() {
    return {
      loader: false,
      loader1: false,
      showModal: false,
      showNotify: false,
      bankChoosen: "",
      stage: "",
      loaderConfirm: false,
      messageSuccess: "You have passed the bank statement stage!",
      showModalError: false,
      messageModal: "",
      stage: "",
      confirmStatus: false,
      notifyMsg: "",
      modalSucess: false,
      getLinkData: "",
      confirmBank: false,
      GTpdf: {
        color: "#0892d0"
      },
      form: {
        bank: "",
        accountNo: "",
        phoneNumber: "",
        date: "",
        // startDate: "",
        // endDate: "",
        dateRange: "",
        ticketId: "",
        password: ""
      },
      message: "Please enter the code you received on your mobile phone",
      formErrors: {},
      amtData: {},
      showRetry: false,
      activeIndex: 0,
      summary: {},
      banks: [{ id: null, name: null }],
      pickerOptions: {
        shortcuts: [
          {
            text: "Last 6 months",
            onClick(picker) {
              const end = new Date("2021-09-16");
              const start = new Date("2022-03-16");
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      tabItems: [
        {
          title: "Make Request",
          percent: "0"
        },
        {
          title: "Confirm Action",
          percent: "53"
        },
        {
          title: "Summary",
          percent: "100"
        }
      ]
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    ...mapActions(["saveCustomerProductOptions"]),
    gotoCreditCheck() {
      this.updateStateFunc();
    },
    updateStateFunc() {
      // console.log("presssed");
      const HTTP = this.$httpUtils.instance;
      HTTP.patch("/onboardingStates", {
        customerid: localStorage.customerId,
        stateid: 2,
        id: localStorage.customerState
      }).then(res => {
        this.$store.commit("saveOnboanrdingState", 2);

        if (res.data) {
          this.modalSucess = true;
          setTimeout(() => {
            this.$emit("updateStatus");
          }, 2000);
        }
      });
    },

    getLink(id) {
      // console.log("calling my function");
      // console.log(this.banks)
      let obj = this.banks.find(x => x.id == id);
      // console.log(obj.bankLinkStatus)
      this.getLinkData = obj.bankLinkStatus;
      this.form.phoneNumber = localStorage.phoneNumber;
    },
    bankRequestPassed() {
      let pass = this.summary.statementOk ? true : false;
      this.markAsCompleted(pass);
      return pass;
    },
    gotoSection(value) {
      this.activeIndex = value;
    },
    validateInputs() {
      const formErrors = [];

      //
      for (let [field, value] of Object.entries(this.form)) {
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }

        switch (field) {
          case "bank":
            if (value === "null" || value === "") {
              formErrors[field] = "Bank cannot be empty.";
            }
            break;
          case "accountNo":
            if (value === "null" || value === "") {
              formErrors[field] = "Account Number cannot be empty.";
            } else if (value.length < 10 || value.length > 11) {
              formErrors[field] = "Account Number should be 10 characters";
            }
            break;
          default:
            break;
        }
      }
      return formErrors;
    },
    validateInputs2() {
      const formErrors = [];

      //
      for (let [field, value] of Object.entries(this.form)) {
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }

        switch (field) {
          case "password":
            if (value === "null" || value === "") {
              formErrors[field] = "Password cannot be empty.";
            }
            break;
          case "ticketId":
            if (value === "null" || value === "") {
              formErrors[field] = "Ticket ID cannot be empty.";
            }
            break;
          default:
            break;
        }
      }
      return formErrors;
    },
    async retryRequest() {
      const data = {
        ticketid: localStorage.ticketId
      };

      // console.log(data);

      this.loader1 = true;
      this.$emit("showLoading", true);
      const HTTP = this.$httpUtils.instance;
      try {
        let res = await HTTP.post("/RequestStatementData/getFeedback", data);

        // console.log(res.data);

        this.$emit("showLoading", false);
        this.loader1 = false;
        // this.gotoSection(this.activeIndex + 1);
        // return;

        if (res.data.data.result.status == "Invalid") {
          this.showModalError = true;
          this.showErrorMsg({ message: res.data.data.result.feedback });
          //  + '. invalid - Please wait for 50 - 10 minutes to receive the code'

          this.showRetry = false;
          this.gotoSection(0);
        } else if (res.data.data.result.status == "Pending") {
          this.message = res.data.data.result.feedback;
          //  + '. pending - Please wait for 5 - 10 minutes to receive the code'
        } else {
          this.message = res.data.data.result.feedback;
          this.gotoSection(this.activeIndex + 1);
        }

        // this.showNotify = true;
        // this.notifyMsg = res.data.message;
      } catch (error) {
        console.log(error);
        this.$emit("showLoading", false);
        // this.showModalError = true;
        this.showErrorMsg({
          messsage: "Unable to complete action, please try again"
        });
      }
    },
    getCurrentStyle(current, today) {
      const style = {};
      if (current.date() === 1) {
        style.border = "1px solid #1890ff";
        style.background = "#fff";
        style.borderRadius = "50%";
      }
      return style;
    },
    okayConfirm() {
      this.confirmStatus = false;
      this.showRetry = false;
      this.activeIndex = 0;
    },
    async makeRequest() {
      this.gotoSection(this.activeIndex + 1);
      return;
      const HTTP = this.$httpUtils.instance;
      let obj = this.banks.find(x => x.id == this.form.bank);
      this.bankChoosen = obj.name;
      const data = {
        customerId: localStorage.customerId,
        accountNo: this.form.accountNo,
        bankId: this.form.bank,
        startDate: this.form.dateRange[0],
        endDate: this.form.dateRange[1],
        customerName: localStorage.firstName + " " + localStorage.lastName,
        phoneNo: this.form.phoneNumber
      };

      if (this.getLinkData == "Y") {
        this.formErrors = this.validateInputs();
        if (Object.keys(this.formErrors).length > 0) return;

        // console.log(data)
        this.loader = true;
        this.$emit("showLoading", true);
        try {
          let res = await HTTP.post(
            "/RequestStatementData/RequestStatement",
            data
          );
          localStorage.ticketId = res.data.ticketid;

          this.$emit("showLoading", false);
          this.loader = false;

          if (res.data.data.result.status == "Pending") {
            this.message = res.data.data.result.feedback;
            //  + '. make request pending - Please wait for 50 - 10 minutes to receive the code'
            this.showRetry = true;
            return;
          }

          if (res.data.data.status == "00") {
            this.message = res.data.data.result.feedback;
            //  + '. Please wait for 5 - 100 minutes to receive the code'

            this.gotoSection(this.activeIndex + 1);
            return;
          }

          // this.showNotify =  true;
          // this.notifyMsg = res.data.message
        } catch (error) {
          console.log(error);
          this.$emit("showLoading", false);

          // this.showNotify =  true;
          // this.notifyMsg = res.data.message
        }
      } else {
        if (this.form.bank) {
          //console.log("it would call");
          this.loader = true;
          HTTP.post(`/RequestStatementData/RequestStatement`, data).then(
            res => {
              if (!res.data) {
                this.loader = false;
                this.confirmBank = true;
                this.gotoSection(this.activeIndex + 1);
              }
            }
          );
        }
      }
    },

    confirmBankFunc(e) {
      this.confirmBank = false;
      this.gotoSection(this.activeIndex + 1);
    },
    async confirmRequest() {
      this.gotoSection(this.activeIndex + 1);
      setTimeout(() => {
        this.confirmStatus = true;
      }, 400);
      return;
      const productType = await this.getProductType(this.getUserSession.id);
      //console.log("product type", productType);
      this.saveCustomerProductOptions(productType);

      const HTTP = this.$httpUtils.instance;
      this.formErrors = this.validateInputs2();
      if (Object.keys(this.formErrors).length > 0) return;
      const data = {
        ticketNo: this.form.ticketId,
        password: this.form.password,
        customerId: this.getUserSession.id,
        productType: productType.id,
        tenure: productType.tenure,
        id: 0
      };

      this.$emit("showLoading", true);
      this.loaderConfirm = true;
      try {
        HTTP.post(`/confirmStatementRequests/confirmStatement`, data).then(
          res => {
            console.log("res.dataaa", res.data);
            this.loaderConfirm = false;
            this.loader = false;

            if (res.data == null) {
              // console.log("204 no response");
              this.loaderConfirm = false;
              this.showModal = true;
            } else if (res.status === 200 && res.data.statementOk == true) {
              this.loaderConfirm = false;
              this.showModal = false;
              this.summary = res.data;
              this.gotoSection(this.activeIndex + 1);
            } else if (res.data.status == 99) {
              (this.loaderConfirm = false), (this.showModal = false);
              this.showErrorMsg({ message: res.data.message });
            } else if (res.status == 200 && res.data.statementOk == false) {
              // this.confirmStatus =  true;
              this.summary = res.data;
              this.loader = false;
              this.gotoSection(this.activeIndex + 1);
              setTimeout(() => {
                this.confirmStatus = true;
              }, 400);
            } else {
              this.showModal = false;
              this.loaderConfirm = false;
            }
            // console.log('response error')
          }
        );
      } catch (error) {
        this.loader = false;
        this.$emit("showLoading", false);
        this.loaderConfirm = false;

        this.showErrorMsg({
          message: "Unable to complete action, please try again."
        });
        this.activeIndex = 0;
      }
    },
    async getProductType(id) {
      const HTTP = this.$httpUtils.instance;

      await HTTP.get(
        `/CustomerProductOptions?filter={"where":{"customerId":${id}},"order":"id DESC","limit":"1"}`
      )
        .then(res => (this.amtData = res.data[0]))
        .catch(err => console.log(err));

      return this.amtData;
    },
    async confirmRequestModal() {
      const HTTP = this.$httpUtils.instance;
      this.loader = true;
      const productType = await this.getProductType(this.getUserSession.id);
      this.saveCustomerProductOptions(productType);

      setTimeout(() => {
        this.formErrors = this.validateInputs2();
        if (Object.keys(this.formErrors).length > 0) return;
        const data = {
          ticketNo: this.form.ticketId,
          password: this.form.password,
          customerId: this.getUserSession.id,
          productType: productType.id,
          tenure: productType.tenure,
          id: 0
        };
        // console.log(data);
        this.$emit("showLoading", true);
        try {
          HTTP.post(`/confirmStatementRequests/confirmStatement`, data).then(
            res => {
              // console.log(res.data);
              this.loader = false;
              if (res.data.statementOk) {
                this.loader = false;
                this.showModal = false;
                this.summary = res.data;
                this.gotoSection(this.activeIndex + 1);
              } else if (res.status == 200 && res.data.statementOk == false) {
                // this.confirmStatus =  true;
                this.summary = res.data;
                this.loader = false;
                this.gotoSection(this.activeIndex + 1);
                setTimeout(() => {
                  this.confirmStatus = true;
                }, 400);
                this.showModal = false;
              } else {
                this.showModalError = true;
                this.loader = false;
                this.showModal = false;
                this.showErrorMsg({
                  message: "Unable to complete action, please try again."
                });
              }
            }
          );
        } catch (error) {
          this.loader = false;

          this.$emit("showLoading", false);
          this.showErrorMsg({
            message: "Unable to complete action, please try again."
          });
          this.activeIndex = 0;
        }
      }, 3000);
    },

    async fetchBanks() {
      const HTTP = this.$httpUtils.instance;
      let res = await HTTP.get("/customerBanks");

      // parse for "arnergy-select" use
      return res.data
        .map(item => {
          return {
            id: item.bankId,
            name: item.bankName,
            bankLinkStatus: item.bankId == 13 || item.bankId == 17 ? "N" : "Y"
            // bankLinkStatus: item.bankLinkStatus,
          };
        })
        .sort((a, b) => {
          return a.name > b.name ? 1 : -1;
        });
    }
  },
  async mounted() {
    this.banks = await this.fetchBanks();
    this.updateTracker(true);
    this.updateStatus(4);
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

h1,
h2,
h3,
h4,
p {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
}

p {
  color: #727272;
  font-size: 16px;
  line-height: 24px;
}

h2 {
  color: #0892d0;
  margin-bottom: 18px;
}

h3 {
  font-weight: 700;
  font-size: 16px;
  color: #000000;
  margin: 20px 0px;
}

h4 {
  font-weight: 700;
  font-size: 16px;
  color: #fe7a11;
  margin: 13px 0px;
}

.summary-container {
  display: flex;
  justify-content: space-between;
}

.download-button {
  border-radius: 5px;
  padding: 14px 36px;
  text-align: center;
  max-width: 240px;
  display: flex;
  background: #fe7a11;
  border: 1px solid #fe7a11;
  color: #ffffff;
  margin-right: 35px;
  cursor: pointer;
}

.download-button-wide {
  border-radius: 5px;
  padding: 14px 36px;
  text-align: center;
  max-width: 240px;
  display: flex;
  background: #fe7a11;
  border: 1px solid #fe7a11;
  color: #ffffff;
  margin-right: 35px;
  cursor: pointer;
}

.summary {
  h2 {
    color: #0892d0;
    margin-bottom: 30px;
    font-weight: 700;
  }

  .summary-table {
    padding: 0px 28px;
    background: #fafafa;
    width: 100%;

    > div {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 24px 0px;
      border-bottom: 1px dashed #e8e2e2;

      p:last-child {
        text-align: right;
        width: 50%;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    .table-base p {
      font-weight: bold;
    }
  }
}

.illustration {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 350px;

  img:first-child {
    margin-bottom: -3rem;
    z-index: 3;
  }
}

.description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #e6f6ff;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892d0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/leaseToOwn/BankStatement.vue